import { Action, getModule, Module, MutationAction, VuexModule, Mutation } from "vuex-module-decorators";
import store from "@/store";
import { ResponseDataType } from "@/form/form.types";
import { ICashbox, ICashboxResponseType } from "@/entity/finance/cashbox/cashbox.types";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { CashboxAddFormRequestType } from "@/form/finance/cashbox/CashboxAddForm.types";
import { CashboxTransferFormRequestType } from "@/form/finance/cashbox/CashboxTransferForm.types";
import { prepareFormData } from "@/store/utils/formDataHelper";

@Module({
    namespaced: true,
    name: "cashbox",
    store,
    dynamic: true,
})
class CashboxModule extends VuexModule {
    items: ICashbox | null = null;
    itemsLoaded = false;
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: ICashbox; itemsLoaded: boolean }> {
        const items = await store.$repository.cashbox.fetchAll(prepareFormData(data));
        let itemsLoaded = false;
        if (items) {
            itemsLoaded = true;
        }
        return { items, itemsLoaded };
    }
    @Action({ rawError: true })
    async transfer(data: CashboxTransferFormRequestType): Promise<ResponseDataType> {
        return await store.$repository.cashbox.transfer(data);
        //return resp;
    }
    @Action({ rawError: true })
    async create(data: CashboxAddFormRequestType): Promise<ResponseDataType> {
        return await store.$repository.cashbox.create(data);
        //return resp;
    }
    @Action({ rawError: true })
    async update(data: CashboxAddFormRequestType): Promise<ResponseDataType> {
        return await store.$repository.cashbox.update(data);
        //return resp;
    }
    @Action({ rawError: true })
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.cashbox.delete({ id: id });
        //return resp;
    }
    @Mutation
    async setReady(st: boolean) {
        this.ready = st;
    }
}

export const CashboxStore = getModule(CashboxModule);
